import { render, staticRenderFns } from "./SinisterSelect.vue?vue&type=template&id=fb9989c6"
import script from "./SinisterSelect.vue?vue&type=script&lang=js"
export * from "./SinisterSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SinisterSelect.vue
// module id = 1518
// module chunks = 31